require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./columbia-county-justice-reinvestment-program.json") })
        }
      }, "path---columbia-county-justice-reinvestment-program");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---columbia-county-justice-reinvestment-program!./.cache/json/columbia-county-justice-reinvestment-program.json
// module id = 856
// module chunks = 231608221292675